"use client";

import { useQuery } from "@tanstack/react-query";
import { workspaceAppsApi } from "../api";
import { workspaceAppsKeys } from "../queryKeys";

export function useUserWorkspaceAppLayoutQuery(workspaceUuid: string) {
  return useQuery({
    queryKey: workspaceAppsKeys.layout(workspaceUuid),
    queryFn: () => workspaceAppsApi.getUserLayout(workspaceUuid),
    enabled: workspaceUuid !== "",
    staleTime: Number.POSITIVE_INFINITY,
  });
}
